// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pbutton{background-color:var(--button-color);color:var(--light-text-color);border:none;padding-bottom:5px;min-width:120px;height:40px;font-size:medium;margin:10px;text-decoration:none}.image{margin:10px;height:90%}.imagedivdoc{border:2px solid var(--primary-color);background-color:#fff;display:flex;flex-direction:column;align-items:center;width:80%;height:600px;margin:auto}", ""]);
// Exports
module.exports = exports;
